var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#3a4d96}.cls-2{fill:#00a569}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9 40a1 1 0 0 1-.9-.84V27.21a.86.86 0 0 1 .84-.84h15.45V21a.87.87 0 0 1 .84-.84h15.74a.87.87 0 0 1 .84.84v9.3h15.45a.87.87 0 0 1 .84.85v8a.86.86 0 0 1-.84.84zm47.41-1.74V32h-14.6v6.27zm-16.31 0V21.88H18v16.38zm-15.73 0v-10.2H1.69v10.2z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9 39.89a.75.75 0 0 1-.73-.73V27.21a.75.75 0 0 1 .73-.73h15.56V21a.75.75 0 0 1 .73-.73h15.73a.75.75 0 0 1 .73.73v9.39h15.51a.74.74 0 0 1 .73.73v8a.75.75 0 0 1-.73.73zm32.7-1.46h14.83v-6.55H33.6zm-15.68 0h14.27V21.76H17.87zm-16.29 0h14.83V27.94H1.57z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 17.81a2 2 0 0 1-.79-.17L25 15.5l-4 2.14a1.73 1.73 0 0 1-.73.17 1.86 1.86 0 0 1-1-.29 1.67 1.67 0 0 1-.62-1.52l.73-4.44-3.2-3.2a1.6 1.6 0 0 1-.06-2.25 1.23 1.23 0 0 1 1-.45l4.49-.67 2-4a1.6 1.6 0 0 1 2.06-.83 1.5 1.5 0 0 1 .73.74l2 4h.06l4.44.67a1.53 1.53 0 0 1 1.29 1.07 1.58 1.58 0 0 1-.4 1.63l-3.25 3.15.75 4.58A1.6 1.6 0 0 1 30 17.81zm-9.27-7.48a1.53 1.53 0 0 1 .49 1.41l-.79 4.44 4-2.14a1.81 1.81 0 0 1 1.51 0l4 2.14h.06l-.79-4.44a1.61 1.61 0 0 1 .45-1.41l3.26-3.14-4.5-.68a1.46 1.46 0 0 1-1.2-.9l-2-4-.28-.11.28.17-2 4a1.54 1.54 0 0 1-1.24.84l-4.49.68z",
    className: "cls-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.edcd6196886000278a0420ee02dff2d7.svg";
export { ForwardRef as ReactComponent };